import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@nerdwallet/react-button';
import InputGroup from '@nerdwallet/react-input-group';
import Link from '@nerdwallet/react-link';
import Select from '@nerdwallet/react-select';
import { Heading } from '@nerdwallet/react-typography'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import throttle from 'lodash/throttle'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import map from 'lodash/map'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import noop from 'lodash/noop';
import classnames from 'classnames';
import Comment from './comment';
import TabDesignComment from './comment-tab-design';
import CommentBox from './comment-box';
import RatingSummary from './rating-summary';
import { fetchGigyaComments, postComment, voteComment, logout, GIGYA_SORT_VALUES, GIGYA_SORT_VALUES_CANONICAL, GIGYA_DEFAULT_SORT_VALUE } from './actions';
import { ElementInteraction, elementInteraction } from '../tracking';
import { setTrk, TrkTag, TrkElement } from '../trk-helper';
var propTypes = {
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  gigya: PropTypes.object,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  streamID: PropTypes.string,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  fetchGigyaComments: PropTypes.func,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  postComment: PropTypes.func,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  voteComment: PropTypes.func,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  logout: PropTypes.func,
  showRatingSummary: PropTypes.bool,
  showComposeBox: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  shouldShowTabDesign: PropTypes.bool,
  showReactSortSelect: PropTypes.bool,
  showWriteReview: PropTypes.bool,
  reviewHeaderText: PropTypes.string,
  reviewButtonOnClick: PropTypes.func
};
var defaultProps = {
  gigya: {},
  showRatingSummary: false,
  showComposeBox: true,
  showWriteReview: false,
  showReactSortSelect: false,
  reviewHeaderText: null,
  reviewButtonOnClick: noop
};

var GigyaComments =
/*#__PURE__*/
function (_Component) {
  _inherits(GigyaComments, _Component);

  function GigyaComments(props) {
    var _this;

    _classCallCheck(this, GigyaComments);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GigyaComments).call(this, props));
    _this.sortComments = _this.sortComments.bind(_assertThisInitialized(_this));
    _this.toggleWriteReview = _this.toggleWriteReview.bind(_assertThisInitialized(_this));
    _this.toggleShowSortOptions = _this.toggleShowSortOptions.bind(_assertThisInitialized(_this));
    _this.loadMoreComments = throttle(_this.loadMoreComments.bind(_assertThisInitialized(_this)), 750, {
      trailing: false
    });
    _this.state = {
      showSortOptions: false,
      showWriteReview: false,
      selectedSortOption: GIGYA_DEFAULT_SORT_VALUE
    };
    return _this;
  }

  _createClass(GigyaComments, [{
    key: "toggleShowSortOptions",
    value: function toggleShowSortOptions() {
      // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate -- directive added automatically by Shepherd migration
      this.setState({
        showSortOptions: !this.state.showSortOptions
      }); // Use helper because sort element is not a separate component we can
      // pass ElementInteraction's triggerInteraction prop to

      elementInteraction({
        elementName: 'nw-comments__sort',
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        interactionType: this.state.showSortOptions ? 'HIDE' : 'SHOW'
      });
    } // reactSelect menu manually sends an element interaction event

  }, {
    key: "sortComments",
    value: function sortComments(value, sendElementInteraction) {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.fetchGigyaComments(this.props.streamID, value, true);
      this.toggleShowSortOptions();
      this.setState({
        selectedSortOption: value
      });

      if (sendElementInteraction) {
        elementInteraction({
          id: 'nw-comments__sort-option',
          elementName: 'nw-comments__sort-option',
          type: 'CLICK',
          sectionCategory: 'comments',
          elementContent: value
        });
      }
    }
  }, {
    key: "loadMoreComments",
    value: function loadMoreComments() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.fetchGigyaComments(this.props.streamID);
    }
  }, {
    key: "toggleWriteReview",
    value: function toggleWriteReview() {
      // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate -- directive added automatically by Shepherd migration
      this.setState({
        showWriteReview: !this.state.showWriteReview
      });
    } // eslint-disable-next-line class-methods-use-this -- directive added automatically by Shepherd migration

  }, {
    key: "renderTopDisclosure",
    value: function renderTopDisclosure() {
      return React.createElement("div", {
        className: "nw-comments__disclaimer nw-comments__disclaimer--top"
      }, React.createElement("p", {
        className: "review-disclosure"
      }, "NerdWallet reviews are the result of independent research by our editorial team while cardholder reviews are contributions from independent users not affiliated with NerdWallet. Banks, issuers and credit card companies are not responsible for any content posted on the NerdWallet site, nor do they endorse or guarantee any posted comments or reviews."));
    }
  }, {
    key: "renderRatingSummary",
    value: function renderRatingSummary() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      if (this.props.showRatingSummary) {
        return React.createElement(RatingSummary // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        , {
          streamID: this.props.streamID // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          ,
          showWriteReview: this.props.showWriteReview // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          ,
          reviewHeaderText: this.props.reviewHeaderText // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          ,
          reviewButtonOnClick: this.props.reviewButtonOnClick // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          ,
          shouldShowTabDesign: this.props.shouldShowTabDesign
        });
      }

      return false;
    }
  }, {
    key: "renderComposeBox",
    value: function renderComposeBox() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      if (this.props.showComposeBox) {
        return React.createElement(CommentBox // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        , {
          gigya: this.props.gigya // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          ,
          streamID: this.props.streamID // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          ,
          error: this.props.gigya.postError // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          ,
          handlePost: this.props.postComment // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          ,
          logout: this.props.logout
        });
      }

      return false;
    }
  }, {
    key: "renderReactSelect",
    value: function renderReactSelect() {
      var _this2 = this;

      var newestValue = GIGYA_SORT_VALUES.DATE_DESC;
      var helpfulValue = GIGYA_SORT_VALUES.VOTES_DESC;
      return React.createElement(InputGroup, {
        className: "nw-comments__sort-select-container",
        label: "Sort by",
        input: React.createElement(Select, {
          className: "nw-comments__sort-select-dropdown",
          onChange: function onChange(e) {
            return _this2.sortComments(e.currentTarget.value, true);
          },
          options: [{
            label: GIGYA_SORT_VALUES_CANONICAL[newestValue],
            value: newestValue
          }, {
            label: GIGYA_SORT_VALUES_CANONICAL[helpfulValue],
            value: helpfulValue
          }],
          fullWidth: true
        })
      });
    }
  }, {
    key: "renderSortSelect",
    value: function renderSortSelect() {
      var _this3 = this;

      var sortOptions = map(GIGYA_SORT_VALUES, function (sortValue, index) {
        var onClick = function onClick() {
          _this3.sortComments(sortValue);
        };

        return React.createElement(ElementInteraction, {
          id: "nw-comments__sort-option",
          elementName: "nw-comments__sort-option",
          type: "CLICK",
          sectionCategory: "comments",
          elementContent: sortValue
        }, React.createElement("div", {
          key: index,
          onClick: onClick,
          className: classnames('nw-comments__header-sort-option', {
            // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
            selected: sortValue === _this3.state.selectedSortOption
          })
        }, GIGYA_SORT_VALUES_CANONICAL[sortValue]));
      });
      return React.createElement("div", {
        className: "nw-comments__header-sort"
      }, React.createElement(Button, {
        className: "nw-comments__header-sort-button",
        onClick: this.toggleShowSortOptions
      }, "Sort"), this.state.showSortOptions && React.createElement("div", {
        className: "nw-comments__header-sort-options"
      }, sortOptions));
    }
  }, {
    key: "renderCommentsHeader",
    value: function renderCommentsHeader() {
      var _this4 = this;

      // We use ratingCount because to be consistent with the gigya/rating component
      var ratingCount = get(this.props, ['gigya', 'ratings', // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      this.props.streamID, 'ratingCount']);
      var title = ratingCount === 1 ? '1 review' : "".concat(ratingCount, " reviews");
      var longTitle = "Showing ".concat(ratingCount, " ").concat(ratingCount === 1 ? 'review' : 'reviews'); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      var selectedTitle = this.props.showReactSortSelect ? longTitle : title;

      var onSortClick = function onSortClick(e, sort) {
        e.preventDefault();

        _this4.sortComments(sort, true);
      }; // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


      var isCurrentSortByDate = this.state.selectedSortOption === 'dateDesc';
      return React.createElement("div", {
        className: "nw-comments__header"
      }, React.createElement("div", {
        className: "nw-comments__header-title"
      }, selectedTitle), this.props.showReactSortSelect ? React.createElement("div", {
        className: "nw-comments__sort-links"
      }, "Sort by", React.createElement(Link, {
        bold: isCurrentSortByDate,
        className: "nw-comments__sort-link",
        color: isCurrentSortByDate ? 'green' : 'neutral-darkest',
        onClick: function onClick(e) {
          return onSortClick(e, GIGYA_SORT_VALUES.DATE_DESC);
        }
      }, "Newest"), React.createElement(Link, {
        bold: !isCurrentSortByDate,
        className: "nw-comments__sort-link",
        color: !isCurrentSortByDate ? 'green' : 'neutral-darkest',
        onClick: function onClick(e) {
          return onSortClick(e, GIGYA_SORT_VALUES.VOTES_DESC);
        }
      }, "Most helpful")) : this.renderSortSelect());
    }
  }, {
    key: "renderComments",
    value: function renderComments() {
      var _this5 = this;

      var comments = get(this.props, // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      ['gigya', 'commentsList', this.props.streamID], []); // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      if (this.props.shouldShowTabDesign) {
        return comments.map(function (comment, index) {
          return React.createElement(TabDesignComment // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          , {
            streamID: _this5.props.streamID,
            comment: comment // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
            ,
            voteComment: _this5.props.voteComment // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
            ,
            gigya: _this5.props.gigya,
            elementPosition: "".concat(index + 1) // eslint-disable-next-line react/no-array-index-key -- directive added automatically by Shepherd migration
            ,
            key: "comment-".concat(index)
          });
        });
      }

      return comments.map(function (comment, index) {
        return React.createElement(Comment // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        , {
          streamID: _this5.props.streamID,
          comment: comment // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          ,
          voteComment: _this5.props.voteComment // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          ,
          gigya: _this5.props.gigya,
          elementPosition: "".concat(index + 1) // eslint-disable-next-line react/no-array-index-key -- directive added automatically by Shepherd migration
          ,
          key: "comment-".concat(index)
        });
      });
    }
  }, {
    key: "renderMoreCommentsButton",
    value: function renderMoreCommentsButton() {
      return (// eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        this.props.gigya.hasMoreComments && React.createElement(ElementInteraction, {
          type: "CLICK",
          id: "nw-comments__more",
          elementName: "nw-comments__more",
          sectionCategory: "comments",
          elementCategory: "button",
          elementDomType: "button"
        }, React.createElement(Button // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        , {
          disabled: this.props.gigya.loading,
          className: "nw-comments__more",
          onClick: this.loadMoreComments // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          ,
          block: this.props.shouldShowTabDesign
        }, "Show more reviews"))
      );
    } // eslint-disable-next-line class-methods-use-this -- directive added automatically by Shepherd migration

  }, {
    key: "renderBottomDisclaimer",
    value: function renderBottomDisclaimer() {
      var _trackingParams;

      var trackingParams = (_trackingParams = {}, _defineProperty(_trackingParams, TrkTag.location, 'nw-comments__footer'), _defineProperty(_trackingParams, TrkTag.element, TrkElement.hyperlink), _trackingParams);
      var termsOfUseURL = setTrk({
        url: '/blog/terms-of-use',
        params: trackingParams
      });
      var postingGuidelinesURL = setTrk({
        url: '/blog/nerdwallets-posting-guidelines',
        params: trackingParams
      });
      return React.createElement("div", {
        className: "nw-comments__disclaimer nw-comments__disclaimer--bottom"
      }, React.createElement("p", {
        className: "review-disclosure"
      }, "Some of the reviews on the NerdWallet site were purchased through a third party provider. Users who post a review directly on the NerdWallet site will not be compensated in any way. Please see our", React.createElement(Link, {
        href: termsOfUseURL,
        target: "_blank",
        rel: "noopener noreferrer"
      }, ' Terms of Use '), "and", React.createElement(Link, {
        href: postingGuidelinesURL,
        target: "_blank",
        rel: "noopener noreferrer"
      }, ' Posting Guidelines '), "for more information."));
    }
  }, {
    key: "render",
    value: function render() {
      var shouldShowTabDesign = this.props.shouldShowTabDesign;
      var containerClass = classnames('nw-comments__container', {
        'tab-design': shouldShowTabDesign
      });
      var containerId = classnames({
        'cardholder-reviews': !shouldShowTabDesign
      });
      return React.createElement("div", {
        className: "nw-comments",
        id: containerId
      }, React.createElement("div", {
        className: containerClass
      }, this.renderTopDisclosure(), this.renderRatingSummary(), shouldShowTabDesign ? React.createElement("div", {
        className: "nw-comments__write-review-container"
      }, !this.state.showWriteReview ? React.createElement("div", {
        className: "nw-comments__review-cta"
      }, React.createElement(Heading, {
        bold: false,
        className: "nw-comments__review-cta-heading",
        color: "green",
        level: 3,
        size: 2,
        chronicle: true
      }, "Already have this card?", React.createElement("br", null), "Tell us what you think."), React.createElement(Button, {
        className: "nw-comments__review-cta-button",
        onClick: this.toggleWriteReview,
        type: "button"
      }, "Review this card")) : null, this.state.showWriteReview ? React.createElement(CommentBox // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      , {
        gigya: this.props.gigya // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        streamID: this.props.streamID // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        error: this.props.gigya.postError // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        handlePost: this.props.postComment // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        ,
        logout: this.props.logout,
        closeWriteReview: this.toggleWriteReview,
        shouldShowTabDesign: true
      }) : null) : this.renderComposeBox(), this.props.showReactSortSelect && this.renderReactSelect(), this.renderCommentsHeader(), this.renderComments(), shouldShowTabDesign ? React.createElement("hr", {
        className: "nw-comments__separator"
      }) : null, this.renderMoreCommentsButton(), this.renderBottomDisclaimer()));
    }
  }]);

  return GigyaComments;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


GigyaComments.displayName = 'Gigya Comments'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

GigyaComments.propTypes = propTypes; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

GigyaComments.defaultProps = defaultProps;
export default connect(function (state) {
  return {
    gigya: state.gigya
  };
}, {
  fetchGigyaComments: fetchGigyaComments,
  postComment: postComment,
  voteComment: voteComment,
  logout: logout
})(GigyaComments);